import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import "../design/projecttasks.css";

class SprintList extends Component {

    constructor(props) {
        super(props);
        this.handleRedirectToTask = this.handleRedirectToTask.bind(this);
    }

    handleRedirectToTask(event, sprintUUID) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.projectUUID + "/Sprint/" + sprintUUID, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.projectUUID + "/Sprint/" + sprintUUID);
        }
    }

    render() {
        const sprints = this.props.sprints;
        if (!sprints) return null;
        const sprintStatuses = this.props.sprintStatuses;
        if (sprintStatuses.length === 0) return null

        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>Sprint name</td>
                            <td>Sprint Status</td>
                        </tr>
                    </thead>
                    <tbody>
                        {sprints.map((sprint) => (
                            <tr className="tr_hover"
                                key={sprint.sprintUUID}
                                onClick={(event) => { this.handleRedirectToTask(event, sprint.sprintUUID) }}
                            >
                                <td>{sprint.sprintName}</td>
                                <td>{sprintStatuses.find(element => element.statusID === sprint.currentStatus).statusName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(SprintList);


// WEBPACK FOOTER //
// ./src/components/sprintlist.js